const API_URL = "https://dev.dimalink.cl/api/Sectores";

/**
 * Crear un sector
 * @param {Object} sector
 */
export async function crearSector(sector) {
  try {
    const response = await fetch(`${API_URL}/crear`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sector),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al crear sector:", error);
    throw error;
  }
}

/**
 * Modificar un sector
 * @param {Object} sector
 */
export async function modificarSector(sector) {
  try {
    const response = await fetch(`${API_URL}/modificar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sector),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al modificar sector:", error);
    throw error;
  }
}

/**
 * Eliminar sector (eliminación lógica = desactivar)
 * @param {Object} sector
 */
export async function eliminarSector(sector) {
  try {
    const response = await fetch(`${API_URL}/desactivar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sector),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al eliminar sector:", error);
    throw error;
  }
}

/**
 * Activar sector
 * @param {Object} sector
 */
export async function activarSector(sector) {
  try {
    const response = await fetch(`${API_URL}/activar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sector),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al activar sector:", error);
    throw error;
  }
}

/**
 * Desactivar sector
 * @param {Object} sector
 */
export async function desactivarSector(sector) {
  try {
    const response = await fetch(`${API_URL}/desactivar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sector),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al desactivar sector:", error);
    throw error;
  }
}
